const getArrayOfValues = (list, field) => {
  let fieldArray = []
  list.map(item => {
    fieldArray.push(item[field])
  })
  return fieldArray
}

export {
  getArrayOfValues
}



// WEBPACK FOOTER //
// ./client/utils/arrayUtils.js